import React from 'react';
import { Trans } from 'react-i18next';

const LoadingMsg = ({className, fontSize, message}) => {

  const s = {
    loader: {
      className: "text-center my-2" || className,
      style:{fontSize: fontSize || "1.4em"},
    },
  };

  return (
    <div {...s.loader}>
      <span className="fa fa-spinner fa-spin mt-2" /> {message? <span>... <Trans>Please Wait</Trans></span>: <span><Trans>Loading...</Trans> <Trans>Please Wait</Trans></span>}.
    </div>
  );
};

export default LoadingMsg;
